/* Just Silver - FAQ page (quiet luxury).
   Live search, topic filter, accordion, copy link, and the shared motion
   (title rise, reveals, count-up, ghost word, reading progress).
   Without this file every answer is simply shown open. */
(function () {
  'use strict';

  var d = document;
  var w = window;
  var root = d.querySelector('[data-jsq-faqs]');
  if (!root) return;
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(w.Shopify && w.Shopify.designMode);
  var anim = !reduce && !design && ('IntersectionObserver' in w);
  var norm = function (s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim(); };

  /* ---------- accordion ---------- */
  var items = $$('.jsq-faq__item').map(function (sec) {
    var btn = $('.jsq-pol__qbtn', sec);
    var q = $('[data-jsq-q]', sec);
    return {
      sec: sec,
      btn: btn,
      region: $('.jsq-pol__a-in', sec),
      q: q,
      label: q.textContent,
      text: norm(q.textContent + ' ' + $('.jsq-faq__answer', sec).textContent),
      topic: sec.getAttribute('data-topic')
    };
  });
  var setItem = function (it, open) {
    it.sec.classList.toggle('is-open', open);
    it.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    it.region.inert = !open;
  };
  items.forEach(function (it, i) {
    setItem(it, i === 0);
    it.btn.addEventListener('click', function () { setItem(it, !it.sec.classList.contains('is-open')); });
  });

  /* ---------- filter + search ---------- */
  var groups = $$('.jsq-faq__group');
  var features = $$('.jsq-faq__feature');
  var topicBtns = $$('.jsq-faq__topic');
  var input = $('[data-jsq-search]');
  var clear = $('[data-jsq-clear]');
  var searchBox = $('.jsq-faq__search');
  var countText = $('[data-jsq-count-text]');
  var empty = $('[data-jsq-empty]');
  var emptyH = $('[data-jsq-empty-h]');
  var topic = 'all';
  var query = '';

  var mark = function (it, words) {
    it.q.textContent = '';
    if (!words.length) { it.q.textContent = it.label; return; }
    var src = it.label;
    var low = norm(src);
    var hits = [];
    words.forEach(function (wd) {
      var from = 0;
      var at;
      while ((at = low.indexOf(wd, from)) > -1) { hits.push([at, at + wd.length]); from = at + wd.length; }
    });
    hits.sort(function (a, b) { return a[0] - b[0]; });
    var pos = 0;
    hits.forEach(function (h) {
      if (h[0] < pos) return;
      if (h[0] > pos) it.q.appendChild(d.createTextNode(src.slice(pos, h[0])));
      var m = d.createElement('mark');
      m.className = 'jsq-faq__hit';
      m.textContent = src.slice(h[0], h[1]);
      it.q.appendChild(m);
      pos = h[1];
    });
    if (pos < src.length) it.q.appendChild(d.createTextNode(src.slice(pos)));
  };

  var apply = function (animate) {
    var words = norm(query).split(' ').filter(Boolean);
    var perTopic = {};
    var shown = 0;
    items.forEach(function (it) {
      var hit = words.every(function (wd) { return it.text.indexOf(wd) > -1; });
      if (hit) perTopic[it.topic] = (perTopic[it.topic] || 0) + 1;
      var show = hit && (topic === 'all' || it.topic === topic);
      it.sec.hidden = !show;
      if (show) shown += 1;
      mark(it, show ? words : []);
      if (show) it.sec.classList.add('is-in');
    });
    features.forEach(function (f) {
      var t = f.getAttribute('data-topic');
      f.hidden = !!words.length || !(topic === 'all' || t === topic);
      if (!f.hidden) f.classList.add('is-in');
    });
    groups.forEach(function (g) {
      var visible = $$('.jsq-faq__item:not([hidden]), .jsq-faq__feature:not([hidden])', g).length > 0;
      var was = !g.hidden;
      g.hidden = !visible;
      $$('[data-jsq-pop]', g).forEach(function (x) { if (visible) x.classList.add('is-in'); });
      if (visible && animate && anim) {
        g.classList.remove('is-entering');
        void g.offsetWidth;
        g.classList.add('is-entering');
      } else if (!was && visible) {
        g.classList.remove('is-entering');
      }
    });
    // counts on the topic buttons follow the search
    var total = 0;
    topicBtns.forEach(function (b) {
      var t = b.getAttribute('data-topic');
      if (t === 'all') return;
      var n = perTopic[t] || 0;
      total += n;
      var badge = $('.jsq-faq__n', b);
      if (badge) badge.textContent = n;
      b.classList.toggle('is-none', n === 0);
    });
    var allBadge = $('.jsq-faq__n[data-n="all"]');
    if (allBadge) allBadge.textContent = total;
    // a short list opens itself
    if (words.length && shown > 0 && shown <= 3) {
      items.forEach(function (it) { if (!it.sec.hidden) setItem(it, true); });
    }
    if (countText) {
      var n2 = shown;
      var word = n2 === 1 ? (root.getAttribute('data-one') || 'question') : (root.getAttribute('data-many') || 'questions');
      countText.textContent = n2 + ' ' + word + (words.length ? ' for “' + query.trim() + '”' : '');
    }
    if (empty) {
      empty.hidden = shown > 0 || features.some(function (f) { return !f.hidden; });
      if (!empty.hidden && emptyH) emptyH.textContent = (root.getAttribute('data-empty') || 'Nothing matches “[q]”').replace('[q]', query.trim());
    }
    if (clear) clear.hidden = !query;
    if (searchBox) searchBox.classList.toggle('is-typing', !!query);
  };

  var setTopic = function (t, animate) {
    topic = t;
    topicBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-topic') === t ? 'true' : 'false'); });
    apply(animate);
  };
  topicBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      setTopic(b.getAttribute('data-topic'), true);
      if (w.matchMedia('(max-width: 63.99em)').matches) {
        var list = $('[data-jsq-list]');
        if (list && list.getBoundingClientRect().top < 0) list.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    });
  });

  var tId;
  if (input) {
    input.addEventListener('input', function () {
      clearTimeout(tId);
      tId = setTimeout(function () { query = input.value; apply(false); }, 120);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && input.value) { e.preventDefault(); input.value = ''; query = ''; apply(false); }
      if (e.key === 'Enter') {
        e.preventDefault();
        var first = items.filter(function (it) { return !it.sec.hidden; })[0];
        if (first) { setItem(first, true); first.sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
      }
    });
  }
  if (clear) clear.addEventListener('click', function () { input.value = ''; query = ''; apply(false); input.focus(); });
  var reset = $('[data-jsq-reset]');
  if (reset) reset.addEventListener('click', function () { if (input) input.value = ''; query = ''; setTopic('all', true); });

  // "/" jumps to the search, as on most help centres
  d.addEventListener('keydown', function (e) {
    if (e.key !== '/' || !input || e.metaKey || e.ctrlKey || e.altKey) return;
    var tag = (d.activeElement && d.activeElement.tagName) || '';
    if (/INPUT|TEXTAREA|SELECT/.test(tag) || (d.activeElement && d.activeElement.isContentEditable)) return;
    e.preventDefault();
    input.focus();
  });

  /* ---------- hero title, word by word ---------- */
  var title = $('[data-jsq-split]');
  if (title) {
    var nWord = 0;
    var wrap = function (text, into) {
      text.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { into.appendChild(d.createTextNode(' ')); return; }
        var o = d.createElement('span');
        o.className = 'jsq-w';
        o.style.setProperty('--w', nWord);
        nWord += 1;
        var i = d.createElement('span');
        i.textContent = part;
        o.appendChild(i);
        into.appendChild(o);
      });
    };
    var nodes = Array.prototype.slice.call(title.childNodes);
    title.textContent = '';
    nodes.forEach(function (node) {
      if (node.nodeType === 3) { wrap(node.textContent, title); return; }
      var shell = node.cloneNode(false);
      wrap(node.textContent, shell);
      title.appendChild(shell);
    });
    title.classList.add('is-split');
    if (anim) setTimeout(function () { title.classList.add('is-in'); }, 40);
    else title.classList.add('is-in');
  }

  /* ---------- count-up ---------- */
  var countUp = function (node) {
    if (reduce || node.getAttribute('data-done')) return;
    var m = /^(\d+(?:\.\d+)?)(.*)$/.exec(node.textContent.trim());
    if (!m) return;
    node.setAttribute('data-done', '1');
    var end = parseFloat(m[1]);
    var dp = (m[1].split('.')[1] || '').length;
    var rest = m[2];
    var start = Date.now() + 200;
    node.textContent = (0).toFixed(dp) + rest;
    var tick = function () {
      var t = Math.min(1, Math.max(0, (Date.now() - start) / 1300));
      node.textContent = (end * (1 - Math.pow(1 - t, 3))).toFixed(dp) + rest;
      if (t < 1) setTimeout(tick, 32);
    };
    setTimeout(tick, 200);
  };

  /* ---------- reveals ---------- */
  var pops = $$('[data-jsq-pop]');
  var shownPop = function (x) {
    x.classList.add('is-in');
    var c = x.matches('.jsq-faq__feature') ? $('[data-jsq-count]', x) : null;
    if (c) countUp(c);
  };
  if (anim && pops.length) {
    var fold = w.innerHeight * 0.95;
    var later = [];
    pops.forEach(function (x) {
      var r = x.getBoundingClientRect();
      if ((r.top < fold && r.bottom > 0) || (r.width === 0 && r.height === 0)) shownPop(x);
      else later.push(x);
    });
    root.classList.add('jsq-pol--anim');
    var heard = false;
    var io = new IntersectionObserver(function (entries) {
      heard = true;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        shownPop(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    later.forEach(function (x) { io.observe(x); });
    setTimeout(function () {
      if (!heard) { later.forEach(function (x) { shownPop(x); }); io.disconnect(); }
    }, 3000);
  } else {
    pops.forEach(shownPop);
  }

  /* ---------- scroll: progress + ghost word ---------- */
  var bar = $('.jsq-pol__progress');
  var hero = $('.jsq-pol__hero');
  var ghost = $('[data-jsq-ghost]');
  var main = $('.jsq-pol__main');
  var onScroll = function () {
    var vh = w.innerHeight;
    if (hero) {
      var hr = hero.getBoundingClientRect();
      if (ghost && !reduce && hr.bottom > 0) ghost.style.setProperty('--gx', Math.round(Math.max(0, -hr.top) * 0.35));
      if (bar) bar.classList.toggle('is-on', hr.bottom < 60);
    }
    if (bar && main) {
      var mr = main.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (vh * 0.5 - mr.top) / Math.max(1, mr.height - vh * 0.5)));
      bar.style.setProperty('--rp', p.toFixed(4));
    }
  };
  if (!design) {
    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---------- copy a link ---------- */
  var toast = $('[data-jsq-toast]');
  var tt;
  var say = function (msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-shown');
    clearTimeout(tt);
    tt = setTimeout(function () { toast.classList.remove('is-shown'); }, 1800);
  };
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.jsq-pol__copy');
    if (!b) return;
    var sec = b.closest('.jsq-faq__item');
    var url = w.location.href.split('#')[0] + '#' + sec.id;
    if (w.history.replaceState) w.history.replaceState(null, '', '#' + sec.id);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { say('Link copied'); }, function () { say('Link ready in the address bar'); });
    } else {
      say('Link ready in the address bar');
    }
  });

  /* ---------- arriving with #question ---------- */
  var openHash = function () {
    if (w.location.hash.length < 2) return;
    var id = decodeURIComponent(w.location.hash.slice(1));
    var it = items.filter(function (x) { return x.sec.id === id; })[0];
    if (!it) return;
    if (it.sec.hidden) setTopic('all', false);
    setItem(it, true);
    setTimeout(function () { it.sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }, 80);
  };
  openHash();
  w.addEventListener('hashchange', openHash);

  /* keep the current page's chip in view */
  var chip = $('.jsq-pol__chips [aria-current="page"]');
  var row = chip && chip.closest('ul');
  if (row && row.scrollWidth > row.clientWidth) {
    row.scrollLeft += chip.getBoundingClientRect().left - row.getBoundingClientRect().left - 20;
  }
})();
